import React, { Fragment } from 'react';
import * as DateUtils         from 'lib/DateUtils';
import * as SchemaStore       from 'lib/stores/SchemaStore';
import history                from 'dashboard/history'
import Button                 from 'components/Button/Button.react';
import DashboardView          from 'dashboard/DashboardView.react';
import Modal from 'components/Modal/Modal.react';
import Label from 'components/Label/Label.react';
import Field from 'components/Field/Field.react';
import FormButton from 'components/FormButton/FormButton.react';
import Fieldset               from 'components/Fieldset/Fieldset.react';
import LoaderContainer        from 'components/LoaderContainer/LoaderContainer.react';
import PushSentRate           from 'components/PushSentRate/PushSentRate.react';
import styles                 from './PushDetails.scss';
import stylesTableColumns     from './PushIndex.scss';
import settingsStyles         from 'dashboard/Settings/Settings.scss';
import subscribeTo            from 'lib/subscribeTo';
import tableStyles            from 'components/Table/Table.scss';
import Toolbar                from 'components/Toolbar/Toolbar.react';
import JsonPrinter            from 'components/JsonPrinter/JsonPrinter.react';
import { tableInfoBuilder }   from 'lib/PushUtils';
import SashiDo from '../../lib/SashiDo';

let getMessage = (payload) => {
  if(payload) {
    let payloadJSON = JSON.parse(payload);
    return payloadJSON.alert ? JSON.stringify(payloadJSON.alert) : payload;
  }
  return '';
}

let getSentInfo = (sendTime, expiration) => {
  //expiration unit is in seconds :(
  if (!sendTime){
    return '';
  }

  let fmtSendTime = getFormattedTime({time: sendTime});
  let fmtExpiration = expiration ? getFormattedTime({time: expiration * 1000}) : null;
  if (expiration){
    return `Sent ${fmtSendTime} and expires ${fmtExpiration}`;
  } else {
    if(DateUtils.isDateAfterNow(sendTime)) {
      return `Will be delivered on ${fmtSendTime}`;
    }

    return `Sent ${fmtSendTime}`;
  }
}

let getFormattedTime = ({ time, is_local }) => {
  let formattedTime = DateUtils.yearMonthDayTimeFormatter(new Date(time), !is_local);
  if(is_local){
    formattedTime += ' Local Time'
  }
  return formattedTime;
}

let getTargetTable = (query, schema) => {
  let targetRows = tableInfoBuilder(query, schema, stylesTableColumns);
  if (!targetRows || targetRows.length === 0) {
    return null;
  } else {
    return (
      <Fieldset
        legend='Target'
        >
        <div className={stylesTableColumns.settingsBox}>
          <div className={[stylesTableColumns.row, stylesTableColumns.title].join(' ')}>
            <div className={stylesTableColumns.header1}>Grouping</div>
            <div className={stylesTableColumns.header2}>Operator</div>
            <div className={stylesTableColumns.header3}>Value</div>
          </div>
          <div className={stylesTableColumns.rows}>
            {targetRows}
          </div>
        </div>
      </Fieldset>
    );
  }
}


let getErrorElements = (os = {}) => {
  return Object.keys(os).map((key) => {
    return (
      <div className={stylesTableColumns.row} key={key}>
        <div className={stylesTableColumns.errors1}>{key}</div>
        <div className={stylesTableColumns.errors2}>{os[key].count}</div>
      </div>
    );
  });
}

let getPushErrors = (errors = {}) => {
  const errorsRows = getErrorElements(errors);

  if (Object.keys(errors).length === 0) {
    return null;
  } else {
    return (
      <div className={stylesTableColumns.settingsBox}>
        <div className={[stylesTableColumns.row, stylesTableColumns.title].join(' ')}>
          <div className={stylesTableColumns.errors1}>Error string</div>
          <div className={stylesTableColumns.errors2}>Error Count</div>
        </div>
        <div className={stylesTableColumns.rows}>
          {errorsRows}
        </div>
      </div>
    );
  }
}



@subscribeTo('Schema', 'schema')
export default class PushDetails extends DashboardView {
  constructor() {
    super();
    this.section = 'Push';
    this.subsection = 'Activity';
    this.state = {
      pushDetails: {},
      showPushModal: false,
      loading: true,
    };
  }

  componentWillMount() {
    this.props.schema.dispatch(SchemaStore.ActionTypes.FETCH);
    let promise = this.context.currentApp.fetchPushDetails(this.props.params.pushId);

    promise.then((pushDetails) => {
      this.setState({ pushDetails });
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.params.pushId !== nextProps.params.pushId) {
      this.setState({ loading: true });
      this.context.currentApp.fetchPushDetails(nextProps.params.pushId).then((pushDetails) => {
        this.setState({ pushDetails });
      }).finally(() => {
        this.setState({ loading: false })
      });
    }
  }

  navigateToActivity() {
    history.goBack();
  }

  renderTargetTable() {
    if(this.state.pushDetails && this.state.pushDetails.attributes) {
      let classes = this.props.schema.data.get('classes');
      let schema = {};
      if(classes){
        let installations = classes.get('_Installation');
        if(typeof(installations) !== 'undefined'){
          installations.forEach((type, col) => {
            schema[col] = type;
          });
        }
      }
      return getTargetTable(this.state.pushDetails.attributes.query, schema, tableStyles);
    }

    return null;
  }

  renderPushRates() {
    let pushDetails = this.state.pushDetails.attributes;
    let res = null;

    if(pushDetails && pushDetails.payload) {

      const isDateAfterNow = DateUtils.isDateAfterNow(pushDetails.pushTime);

      res = (
        <div>
          { !isDateAfterNow &&
            <PushSentRate numSent={pushDetails.numSent} numFailed={pushDetails.numFailed} />
          }
          <Fieldset
            color={isDateAfterNow && 'orange'}
            legend={isDateAfterNow ? 'Scheduled Message' : 'Message Sent'}
            description={getSentInfo(pushDetails.pushTime, pushDetails.expiration)}>
            <div className={styles.settingsBox}>
              <div className={styles.headline}>{getMessage(pushDetails.payload)}</div>
            </div>
          </Fieldset>
        </div>
      );
    }

    return res;
  }

  renderCancelPush() {
    let pushDetails = this.state.pushDetails.attributes;
    let res = null;

    if (pushDetails && pushDetails.payload) {

      const isDateAfterNow = DateUtils.isDateAfterNow(pushDetails.pushTime);

      if (isDateAfterNow) {
        res = (
          <Fieldset
            legend='Push Notification Management'
            description='These options will affect this push notification.'>
            <div className={styles.settingsBox}>
              <Field
                label={
                  <p>&nbsp;</p>
                }
                input={
                  <FormButton
                    color='red'
                    value='Delete this Push Notification now!'
                    onClick={() => this.openPushModal()} />
                }
              />
            </div>
          </Fieldset>
        );
      }
    }

    return res;
  }

  renderErrorsTable() {
    let pushDetails = this.state.pushDetails.attributes;
    let res = null;

    if(pushDetails && pushDetails.errors) {

      let android = pushDetails.errors['android'];
      let ios = pushDetails.errors['ios'];

      res = (
        <div>
          {
            ios &&
              <Fieldset
                legend='Failed iOS Pushes'
                descriptionWithHTML='You can find the official APNS list with the possible error codes
                  <a href="https://developer.apple.com/library/content/documentation/NetworkingInternet/Conceptual/RemoteNotificationsPG/CommunicatingwithAPNs.html#//apple_ref/doc/uid/TP40008194-CH11-SW17" target="_blank" rel="noreferrer noopener">here</a>'>
                {getPushErrors(ios)}
              </Fieldset>
          }
          {
            android &&
              <Fieldset
                legend='Failed Android Pushes'
                descriptionWithHTML='You can find the official Google FCM list with the possible error codes
                  <a href="https://firebase.google.com/docs/cloud-messaging/http-server-ref#table9" target="_blank" rel="noreferrer noopener">here</a>'>
                {getPushErrors(android)}
              </Fieldset>
          }
        </div>
      );
    }

    return res;
  }

  getPayload() {
    let pushDetails = this.state.pushDetails.attributes;
    let res = null;


    if(pushDetails && pushDetails.payload) {
      res = pushDetails.payload;

      res = (
        <Fieldset
          legend={'JSON Preview'}
          description={''}>
          <div className={styles.settingsBox}>
            {
              <JsonPrinter object={JSON.parse(pushDetails.payload)}  />
            }
          </div>
        </Fieldset>
      );
    }

    return res;
  }

  openPushModal() {
    this.setState({
      showPushModal: true
    });
  }

  closePushModal() {
    this.setState({
      showPushModal: false
    });
  }

  cancelPushConfirm() {
    SashiDo.cancelPushNotification({
      serviceName: this.context.currentApp.serviceName,
      pushId: this.props.params.pushId,
    }).then(() => {
      this.navigateToActivity();
    }).catch((e) => {
      console.error(e);
    })
  }

  renderContent() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    const cancelPushModal = (
      this.state.showPushModal
        ?
          <Modal
            type={Modal.Types.DANGER}
            title={'Delete Scheduled Push Notification'}
            subtitle='Be careful, this action cannot be undone!'
            confirmText='Confirm and Delete'
            cancelText={'Cancel'}
            onCancel={() => this.closePushModal()}
            onConfirm={() => this.cancelPushConfirm()}>
            <div style={{ padding: '20px' }}>
              You will delete this Push Notification entirely, and we'll not send it to any of your users.
            </div>
          </Modal>
        : null
    );

    return (
      <div className={classes.join(' ')}>
        <div className={styles.settings_page}>
          <Toolbar section='Push' subsection='Push Notification Details' details={`ID: ${this.props.params.pushId}`}>
            <Button value='Go Back' onClick={this.navigateToActivity.bind(this)} />
          </Toolbar>
          <div className={[styles.holder].join(' ')}>
            <LoaderContainer close={true} inner={true}>
              {
                this.state.pushDetails && this.state.pushDetails.attributes && this.state.pushDetails.attributes.errorMessage
                  ?
                    <Fieldset
                      legend={'Error'}
                      description={''}>
                      <div className={styles.settingsBox}>
                        {
                          <JsonPrinter object={JSON.parse(this.state.pushDetails.attributes.errorMessage)} />
                        }
                      </div>
                    </Fieldset>
                  :
                    <Fragment>
                      {this.renderPushRates()}
                      {this.renderErrorsTable()}
                      {this.renderTargetTable()}

                    </Fragment>
              }
              {this.getPayload()}
              {this.renderCancelPush()}
              {cancelPushModal}
            </LoaderContainer>
          </div>
        </div>
      </div>
    );
  }
}
